import InfoTip, {P} from '../../../components/info-tip/info-tip';

const EmployeeNumberPrefixInfo = function () {
  return (
    <InfoTip
      info={
        <section className={'w-[415px]'}>
          <h3>工號編碼規則說明(工號由「前置碼+流水碼」組成)：</h3>
          <P>
            1.工號就像是貴公司給予員工的身分證號碼，每位員工都會有一個工號。
            <br />
            Apollo XE的工號是由前置碼+流水碼組成。
          </P>
          <P>
            2.工號除了可辨別員工，也可以使用前置碼來設計辦別身份，例如：
            <br />
            正職員工前置碼為E；契約員工前置碼為B；派遣員工前置碼為C。
          </P>
        </section>
      }
    />
  );
};

export default EmployeeNumberPrefixInfo;
